// extracted by mini-css-extract-plugin
export default {"paginationPageDropdownWrap":"Rent_paginationPageDropdownWrap__XSnwy","catalogContainer":"Rent_catalogContainer__HeHqo"};